module.exports = __webpack_public_path__ + "static/media/arrowRight.27afc1b4.svg";